// components/Common/SafeChip.jsx

import Chip from '@mui/material/Chip';

export default function SafeChip({ label, color = 'default', ...rest }) {
  return (
    <Chip
      label={label}
      color={color}
      variant="outlined"
      // ① 클릭 관련 prop 제거
      {...rest}             // size="small" 등 나머지 전달
    />
  );
}
